export default "__VITE_ASSET__beaf9583__"